import { Transform } from '../4d-objects';
import { from, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { Vasat } from 'vasat';
import {  Renderer,PlottableReference } from '../renderer'
const Cesium = (<any>window).Cesium


/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
export class WMTSTransformRenderer extends Renderer<Transform>{

  constructor(private viewer:any){
    super()
    this._log();
  }

  onAdd(t:Transform, args?:any){
    
    var url:string =t['url'] || t.file('WMTS')
    var layer = (args ? args.layer : null) || (t['proxyMeta']?t['proxyMeta'].layer_id:null)

    this._log('onAdd',[t,args, url, layer]);

    if(args && args.onInit) { args.onInit(t,{url,layer}); }
    
    var shadedRelief1 = new Cesium.WebMapTileServiceImageryProvider({
      url : args?args.url:url,
      layer : layer,
      style : 'default',
      format : 'image/jpeg',
      tileMatrixSetID : 'default028mm',
      parameters:{
        transparent:true,
        format:'image/png'
      }
    });

    if(args && args.onStart) { args.onStart(t,shadedRelief1); }

    var obj = this.viewer.imageryLayers.addImageryProvider(shadedRelief1);

    if(args && args.onProcess) { args.onProcess(t,obj); }

    if ( shadedRelief1.errorEvent ) {
      this.monitorEvent('errorEvent',shadedRelief1.errorEvent);
    }

    var pr:PlottableReference = {
      plottable:t,
      object:obj
    }

    if(args && args.onEnd) { args.onEnd(t,pr); }
    
    return of(pr)
  
  }
  onRemove(t:Transform,pr:PlottableReference){
    this.viewer.imageryLayers.remove(pr.object)
  }
}
